import { Link } from "react-router-dom";
import { trendingList } from "@/mocks/videos";

export default function TrendingList() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14" aria-label="热门榜单">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
            热门榜单
          </h2>
          <p className="text-sm text-foreground-500 mt-1">全网最受欢迎的视频排行</p>
        </div>
        <span className="text-xs text-foreground-400 flex items-center gap-1">
          <i className="ri-refresh-line"></i>
          每日更新
        </span>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        {trendingList.map((video, index) => (
          <Link
            key={video.id}
            to={`/article/${video.id}`}
            className="group flex items-center gap-4 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
          >
            <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center">
              {index < 3 ? (
                <span className={`text-lg font-bold ${
                  index === 0 ? "text-accent-500" : index === 1 ? "text-primary-500" : "text-secondary-500"
                }`} style={{ fontFamily: "var(--font-heading)" }}>
                  {index + 1}
                </span>
              ) : (
                <span className="text-sm font-medium text-foreground-400">{index + 1}</span>
              )}
            </div>

            <div className="flex-shrink-0 w-16 h-10 md:w-20 md:h-12 rounded overflow-hidden">
              <img
                src={video.thumbnail}
                alt={video.title}
                title={`${video.title} - 99视频热门`}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {video.title}
              </h3>
              <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
                <span>{video.category === "dianying" ? "电影" : video.category === "dianshiju" ? "电视剧" : video.category === "zongyi" ? "综艺" : video.category === "dongman" ? "动漫" : video.category === "tiyu" ? "体育" : video.category === "yinyue" ? "音乐" : video.category}</span>
                <span className="flex items-center gap-0.5">
                  <i className="ri-fire-line text-accent-500"></i>
                  {video.views}
                </span>
              </div>
            </div>

            <div className="flex-shrink-0 flex items-center gap-1 text-xs text-foreground-400">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {video.rating}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}